<template lang="pug">
.login--content
  .content__left
    .middle
      h1.title.is-1 Bienvenido
      h2.subtitle.is-2 al gestor de cotizaciones
      .benefits__text
        span Con este sistema podrás:
        ul
          li Crear una cotización
          li Seguir una cotización
  .content__right
      .password-policies-wrapper
          .title-update-password Olvidé mi contraseña
          .subtitle-update-password Ingresa tu correo electrónico, te enviaremos un link para restablecer tu contraseña
          .email.field-container
              b-field(class="input-wrapper" :type="typeInputEmail" custom-class="is-label-input" label="Correo electrónico")
                  b-input(
                      @input="handleEmail($event)"
                      :value="email"
                      class="email-input"
                  )
                  p(class="errorLabel" v-show="showErrorEmail") Debes ingresar un formato válido
          .button-wrapper
            button.primary-button-xs( @click="sendLink", :disabled="buttonDisabled") Enviar Link
  modal-reset-password-email-success( :email="email")
</template>

<script>
import PasswordRepository from '../services/PasswordRepository';
import ModalResetPasswordEmailSuccess from '../views/modals/ResetPasswordEmail';
import { isCorrectEmailFormat } from '../utils/validations';

export default {
    components: { ModalResetPasswordEmailSuccess },
    data() {
      return {
        buttonDisabled: true,
        showErrorEmail: false,
        email: "",
        typeInputEmail: "",
      }
    },

    methods: {
        handleEmail(value) {
            this.email = value
            if (isCorrectEmailFormat(value)) {
                this.typeInputEmail = ""
                this.showErrorEmail = false
                this.buttonDisabled = false
            } else {
                this.typeInputEmail = "is-danger"
                this.showErrorEmail = true
                this.buttonDisabled = true
            }
        },
        sendLink() {
          const loader = this.$buefy.loading.open()
            const body = {
              email: this.email
            }
            PasswordRepository.resetPasswordSendEmail(body).then( (result) => {
              loader.close()
              this.$modal.show('modal-reset-password-email-success')
            }).catch((error) => {
              loader.close()
            })
        },

        isButtonActive() {
            this.buttonDisabled = false
        },
    }
}
</script>

<style lang="scss" scope>
@import "~bulma/sass/utilities/mixins";
@import '../assets/scss/variables.scss';

.login--content {
  display: flex;
  height: 100vh;
  padding: 32px 22px;
  box-sizing: border-box;

  .content__left {
    display: none;
    display: none;
    flex-direction: column;
    justify-content: center;
    align-items: flex-end;
    background-image: url('../assets/images/login-background.jpg');
    background-color: white;
    width: 100%;
    max-width: 960px;
    background-repeat: no-repeat;
    background-position: left top;
    background-size: cover;
    text-align: left;
    border-radius: 16px;

    @include desktop {
      display: flex;
    }

    .middle {
      width: 100%;
      max-width: 580px;
      margin-right: 2.5em;
      display: none;

      h1 {
        color: white;
        font-weight: 100;
      }
      h2 {
        color: white;
        font-weight: 100;
      }

      .benefits__text{
        margin-top: 3.5em;
        color: white;

        span{
          display: block;
          font-weight: bold;
          font-size: 1.5em;
          margin-bottom: 1em;
        }

        ul{
          margin-left: 1.3em;

          li {
            font-weight: 100;
            font-size: 1.5em;
            list-style-type: disc;
          }
        }
      }
    }
  }

  .content__right {
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    .middle {
      width: 360px;
      margin: 0 auto;

      form {
        display: flex;
        flex-direction: column;
      }
      .logo{
        margin-bottom: 1.5em;
        text-align: center;
        img{
          width: 50%;
          margin: 0 auto;
        }
      }
      .help__text{
        color: #ABABAB;
        text-align: center;
        font-size: 1em;
      }

      .field{
        margin-bottom: 2em;
        text-align: left;
        &.big-margin{
          margin-top: 2em;
          margin-bottom: 1em;
        }

        span{
          font-size: 1.375em;
          color: #878787;
          font-weight: 100;
        }

        input {
          width: 100%;
          max-width: 320px;
          padding: 0.5em 0;
          border: none;
          border-bottom: 1px solid #ABABAB;
          font-family: 'mirai-bold_font';
          color: #595959;
          font-size: 1.375em;
          border-radius: 4px;

          &.field__error{
            border-bottom: 1px solid #FF6D46;
          }
        }

        .button {
          color: white;
          border-radius: 25px;
          font-size: 1.125em;
          background-color: #FF6D46;
          width:187px;

          &:hover{
            background-color: #F45327;
          }
        }

        &.center{
          text-align: center;
        }
      }
    }
  }
    .password-policies-wrapper {
        max-width: 381px;
    }
    .title-update-password {
        font-size: 24px;
        font-weight: bold;
        color: $primary;
        text-align: center;
        margin-bottom: 40px;
    }
    .subtitle-update-password {
        font-size: 16px;
        text-align: left;
        margin-bottom: 32px;
    }
    .button-wrapper {
        display: flex;
        justify-content: center;
    }
    .email.field-container {
        margin-bottom: 40px;
    }
    .input-wrapper {
        flex-direction: column;
    }
    .errorLabel {
        color: $primary;
    }
    .is-danger.input {
    border-color: $primary;
    border-radius: 4px !important;
    }
    .is-danger.input:focus {
        box-shadow: 0 0 0 0.125em rgba(255,109,70,0.25) !important;
        -webkit-box-shadow: 0 0 0 0.125em rgba(255,109,70,0.25) !important;
    }

    .field.has-addons .control:not(:first-child):not(:last-child) .input {
        border-radius: 4px !important;
    }
}
</style>